export default function setSearchContestReleaseAction(searchContestRelease) {
    return {
        type: 'SET_SEARCH_CONTEST_RELESE',
        payload: searchContestRelease
    }
}